import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconBoxOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M23.99 5.5a.33.33 0 0 0-.193-.31L12.13.033A.4.4 0 0 0 11.99 0a.3.3 0 0 0-.13.027L.193 5.2A.33.33 0 0 0 0 5.51v13a.33.33 0 0 0 .193.297l11.667 5.156q.061.032.13.037.069 0 .13-.027l11.667-5.156a.33.33 0 0 0 .193-.297zm-12.823 5.687v10.666l-9.53-4.186V7zm9.846-5.434-9.023 4-9.023-4L11.99 1.77zm1.334 11.907-9.534 4.207V11.2l9.53-4.233z" /></svg>
);
